export default "__VITE_ASSET__cfd97a1a__"